<template>
  <v-container fluid>
    <v-row
      align="center"
      justify="center"
      class="ma-0"
    >
      <v-card
        width="100%"
        elevation="10"
      >
        <v-card-title class="title">
          Novidades
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            dark
            class="mb-2"
            @click="navigateCreateNews"
          >
            Criar nova
          </v-btn> 
        </v-card-title>
        <v-card-text>
          <v-container fluid>
            <v-row
              v-if="isLoading"
              align="center"
            >
              <v-progress-circular
                :size="50"
                color="primary"
                indeterminate
              ></v-progress-circular>         
            </v-row>
            <v-row
              v-else
              align="center"
            >
              <v-col
                cols="12"
                md="12"
                lg="12"
                xl="12"
              >
                <v-data-table
                  :headers="headers"
                  :items="news"
                  class="elevation-0"
                  :sort-by="['dh_created']"
                  :sort-desc="[true]"                  
                >
                  <template v-slot:item.bl_show="{ item }">
                    <v-chip
                      class="ma-2"
                      color="green"
                      text-color="white"
                      v-if="item.bl_show"
                    >
                      SIM
                    </v-chip>

                    <v-chip
                      v-else
                      class="ma-2"
                      color="red"
                      text-color="white"
                    >
                      NÃO
                    </v-chip>
                  </template>
                  <template v-slot:item.dh_created="{ item }">
                    <span>{{item.dh_created | formatDatetime}}</span>
                  </template>                     
                  <template v-slot:item.actions="{ item }">
                    <v-icon
                      small
                      class="mr-2"
                      @click="editItem(item)"
                    >
                      mdi-pencil
                    </v-icon>
                    <v-icon
                      small
                      @click="deleteItem(item)"
                    >
                      mdi-delete
                    </v-icon>
                  </template>                  
                </v-data-table>                
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-row>

  </v-container>
</template>

<script>
import moment from 'moment'
import {listNews, deleteNews} from "@/api/api-news";
import {NOTIFICATION_TYPES, NotificationOptions} from "../../helpers/notify"
import dialog, {DIALOG_TYPES, DialogOptions} from "../../helpers/dialogs"

export default {
  name: "ListNews",
  components: {

  },  
  data() {
    return {
      isLoading: false,
      news: [],
      headers: [
        {
          text: 'Título',
          align: 'start',
          sortable: false,
          value: 'title',
        },
        {
          text: 'Publicado',
          align: 'start',
          sortable: true,
          value: 'bl_show',
        },
        {
          text: 'Criado em',
          align: 'start',
          sortable: true,
          value: 'dh_created',
        },             
        { text: 'Ações', value: 'actions', sortable: false },
      ],      
    }
  },
  filters: {
    formatDatetime(date) {
      return moment(date).format("DD/MM/YYYY hh:mm")
    }      
  },  
  methods: {
    navigateCreateNews() {
      this.$router.push({ path: 'manager-news', query: { option: 0, item: null } })
    },
    editItem (item) {
      this.$router.push({ path: 'manager-news', query: { option: 1, item: window.btoa(JSON.stringify(item))} })
    },
    deleteItem (item) {
      dialog(new DialogOptions({
        title: "Tem certeza?",
        content: `Você tem certeza que deseja deletar esta novidade?`,
        confirmText: "SIM, DELETAR NOVIDADE",
        cancelText: "CANCELAR",
        type: DIALOG_TYPES.CONFIRM,
        onConfirm: () => {
          deleteNews(this.$apiAuth.getAuthToken(), item.id_mappa_update)
          .then(() => {
            this.$notify(new NotificationOptions({
              message: "Novidade excluída com sucesso.",
              type: NOTIFICATION_TYPES.SUCCESS,
            }))
            this.getListNews()
          })
          .catch(() => {
            this.$notify(new NotificationOptions({
              message: "Não conseguimos excluir a novidade",
              type: NOTIFICATION_TYPES.ERROR,
            }))
          }) 
        },
      }))
    },
    getListNews() {
      this.isLoading = true
      listNews(this.$apiAuth.getAuthToken())
      .then((res) => {
          this.news = res.data.data
          this.isLoading = false
      })
      .catch(() => {
        this.$notify(new NotificationOptions({
          message: "Não conseguimos obter a lista de novidades.",
          type: NOTIFICATION_TYPES.ERROR,
        }))
        this.isLoading = false
      })    
    }
  },
  mounted() {
    this.getListNews()
  }
}
</script>

<style>
  .ck-content {
    min-height: 200px !important;
  }
</style>